import _ from 'lodash';

import { core, toJSON, toJSONArray } from '@tock/coretypes';
import { dashboard } from 'types';

import AppConstants from 'constants/AppConstants';

interface State {
  isInitialized: boolean;
  requestInProgress: boolean;
  data: dashboard.SeatingTemplate[];
  tickets: { [id: number]: core.TicketType };
}

const initialState: State = {
  isInitialized: false,
  data: [],
  requestInProgress: false,
  tickets: {},
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.TEMPLATE_FETCH_ALL_DONE: {
      const batchResponses = payload;
      const seatingTemplates: dashboard.SeatingTemplate[] = toJSONArray(batchResponses[0]);
      const ticketTypes: core.TicketType[] = toJSONArray<core.TicketType>(batchResponses[1]);
      const ticketTypeDict: { [id: number]: core.TicketType } = {};
      _.forEach(ticketTypes, (ticketType) => {
        ticketTypeDict[ticketType.id] = ticketType;
      });
      return {
        ...state,
        data: _.sortBy(seatingTemplates, 'name'),
        isInitialized: true,
        requestInProgress: false,
        tickets: ticketTypeDict,
      };
    }
    case AppConstants.TEMPLATE_ADD_DONE:
      return {
        ...state,
        data: _.concat(state.data, toJSON(payload)),
        isInitialized: true,
        requestInProgress: false,
      };
    case AppConstants.TEMPLATE_UPDATE_DONE: {
      const updatedTemplate = toJSON<dashboard.SeatingTemplate>(payload);
      return {
        ...state,
        data: _.concat(
          _.filter(state.data, (entry) => {
            return entry.id !== updatedTemplate.id;
          }),
          updatedTemplate
        ),
        isInitialized: true,
        requestInProgress: false,
      };
    }
    case AppConstants.TEMPLATE_FETCH_ALL_STARTING:
    case AppConstants.TEMPLATE_ADD_STARTING:
    case AppConstants.TEMPLATE_UPDATE_STARTING:
      return {
        ...state,
        isInitialized: false,
        requestInProgress: true,
      };
    case AppConstants.TEMPLATE_FETCH_ALL_FAILED:
    case AppConstants.TEMPLATE_ADD_FAILED:
    case AppConstants.TEMPLATE_UPDATE_FAILED:
      return {
        ...state,
        isInitialized: true,
        requestInProgress: false,
      };

    default:
      return state;
  }
}
